import { render, staticRenderFns } from "./OtpValidation.vue?vue&type=template&id=7926cb92"
import script from "./OtpValidation.vue?vue&type=script&lang=js"
export * from "./OtpValidation.vue?vue&type=script&lang=js"
import style0 from "./OtpValidation.vue?vue&type=style&index=0&id=7926cb92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports